import React from "react";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import { Grid2 as Grid, LinearProgress, Typography } from "@mui/material";

const useStyles = makeStyles((theme) => ({
	root: {
		color: theme.palette.primary.fontColor,
		backgroundColor: theme.palette.primary.main,
		fontSize: "14pt",
		fontWeight: "100",
		height: "100vh",
		width: "100vw",
		display: "flex",
		flexGrow: 1,
	},
	bar: {
		backgroundColor: theme.palette.custom.jbAppBar.background,
	  },
	grid: {
		flexGrow: 1,
		width: "100vw",
		margin: 0
	}
}));

export default function Splash(props) {
	const classes = useStyles();
	const { title, icon, secondaryText } = props;
	return (
		<div className={classes.root}>
			<Grid className={classes.grid}>
				<Grid container className={classes.grid} justifyContent="center" spacing={7}>
					<Grid size={12}/>					
					<Grid size={12}>
						<Typography variant="h2" align="center">{title}</Typography>
					</Grid>
					<Grid container size={12} justifyContent="center">
						{icon}
					</Grid>
					<Grid size={10}>
						<LinearProgress className={classes.bar}/>
					</Grid>
					<Grid size={12}>
						<Typography style={{overflowWrap: 'break-word'}} variant="subtitle1" align="center">
							{secondaryText}
						</Typography>
					</Grid>					
				</Grid>
				
			</Grid>
		</div>
	);
}

Splash.propTypes = {
	title: PropTypes.string.isRequired,
	icon: PropTypes.node.isRequired,
	secondaryText: PropTypes.string,
};
